import { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogTitle, IconButton, Slide, Stack, Tooltip } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import { DebFormFilePicker, DebFormSelect, DebFormTextInput, DebFormPasswordInput} from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import { company } from "../../services/companies";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { companyValidationSchema } from "../../schemas/company";
import { file } from "../../services/file";
import { BugReport, ContentCopy } from "@mui/icons-material";
import { mobileConnection } from "../../services/mobile-connection";
import { DEBQ } from "../../constants/mobileConnectionTestSystems";
import copy from 'copy-to-clipboard';

//TRANSICIÓN DEL ALERT DE ELIMINACIÓN
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const newCompanyValues = {
    id: "",
    name: "",
    logo: null,
    dominio: "",
    extension: "",
    debqUrl: "",
    debqUser: "",
    debqPassword: "",
    debqToken: "",
};

function Companies() {
    // MODAL DE EDICIÓN / CREACIÓN
    const [modalState, setModalState] = useState(false);
    const [modalInitialValues, setModalInitialValues] =
        useState(newCompanyValues);
    const [companies, setCompanies] = useState([]);

    const getCompanies = async () => {
        setCompanies(await company.getAll());
    };

    useEffect(() => {
        getCompanies();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const modifiedCompanies = [...companies].map((company) => ({
        ...company,
        branches: company.branchList.map((branch) => branch.name).join(', '),
    }));

    const handleSubmit = async (values) => {

        // si viene un archivo lo subimos
        if(values.logo instanceof File){
            try {
                const { fileName } = await file.upload(values.logo, values.name);
                // reemplazamos para mandar solo el nombre del archivo
                values.logo = fileName;
            }catch (error) {
                //abortamos el form subition
                enqueueSnackbar("Error cargando imagen de logo", {
                    preventDuplicate: true,
                    variant: "error",
                });
                return;
            }
        }
            
        try {
            if (values.id) {
                //estamos editando
                const res = await company.update(values);
                enqueueSnackbar("Compañía editada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            } else {
                const res = await company.create(values);
                enqueueSnackbar("Compañía creada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            }
            closeModal();
            getCompanies();
        } catch (error) {
            if (values.id) {
                enqueueSnackbar("Ocurrió un error al editar la compañía", {
                    preventDuplicate: true,
                    variant: "error",
                });
            } else {
                enqueueSnackbar("Ocurrió un error al crear la compañía", {
                    preventDuplicate: true,
                    variant: "error",
                });
            }
        }
    };

    const openModal = () => {
        setModalState(true);
    };

    const closeModal = () => {
        setModalState(false);
        setModalInitialValues(newCompanyValues);
    };

    const handleEdit = (company) => {
        setModalInitialValues(company);
        openModal();
    };
    const handleCreateCompany = () => {
        setModalInitialValues(newCompanyValues);
        openModal();
    };


    const handleTest = async (company) => {

        const debQTestBody = {
        id: company.id,
        url: company.debqUrl,
        token: company.debqToken,
        system: DEBQ
        };

        try {
            const res = await mobileConnection.testConnection(debQTestBody);
            enqueueSnackbar("Test OK", {
                preventDuplicate: true,
                variant: "warning",
            });
        } catch (error) {
            enqueueSnackbar(`Error Status: ${error.response.status}`, {
                preventDuplicate: true,
                variant: "error",
            });
            enqueueSnackbar(error.response.data, {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };
    
      // ALERT DE ELIMINACIÓN
      const [selectedDelete, setSelectedDelete] = useState();
      const [openAlert, setOpenAlert] = useState(false);
      const handleAlertClose = () => {
          setOpenAlert(false);
      };
      const handleAlertOpen = (selectedCompany) => {
        setSelectedDelete(selectedCompany);
          setOpenAlert(true);
      };

    const handleDelete = async () => {
        try {
            const res = await company.delete(selectedDelete.id);
            enqueueSnackbar("Se eliminó la compañía " + selectedDelete.name, {
                preventDuplicate: true,
                variant: "success",
            });
            handleAlertClose();
            getCompanies();
        } catch (error) {
            enqueueSnackbar("Ocurrió un error eliminando la compañía", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

     //COPIAR TOKEN
    const handleCopy = (event, value) => {
        event.stopPropagation();
        copy(value);
        enqueueSnackbar(("Se copió el Token"), { 
        preventDuplicate: true, 
        variant: 'success'
    });
    };
    
    return (
        <Box>
            <Header title="COMPAÑÍAS" subtitle="Lista de Compañías" />
            <DataTable
                loading={!companies.length}
                rows={modifiedCompanies}
                columns={[
                    { field: "id", headerName: "ID", flex: 0.1 },
                    {
                        field: "name",
                        headerName: "Nombre",
                        flex: 1,
                        renderCell: (params) => (
                            <Tooltip title={params?.value ?? ""} arrow>
                                <span className="table-cell-trucate">
                                    {params?.value ?? ""}
                                </span>
                            </Tooltip>
                        ),
                    },
                    {
                        field: "dominio",
                        headerName: "Dominio",
                        flex: 1,
                        renderCell: (params) => (
                            <Tooltip title={params?.value ?? ""} arrow>
                                <span className="table-cell-trucate">
                                    {params?.value ?? ""}
                                </span>
                            </Tooltip>
                        ),
                    },
                    {
                        field: "extension",
                        headerName: "Extension",
                        flex: 1,
                        renderCell: (params) => (
                            <Tooltip title={params?.value ?? ""} arrow>
                                <span className="table-cell-trucate">
                                    {params?.value ?? ""}
                                </span>
                            </Tooltip>
                        ),
                    },
                    { field: "debqToken", headerName: "Token DebQ", flex: 1.2,
                    renderCell: (params) => (
                        <>
                        <IconButton
                            onClick={(event) => handleCopy(event, params?.value ?? "")}
                            aria-label="copy"
                        >
                            <ContentCopy />
                        </IconButton>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{params?.value ?? ""}</span>
                        </>
                    ),
                    },
                    
                ]}
                rowActions={[
                    {
                        label: "Editar",
                        icon: <EditIcon />,
                        action: handleEdit,
                    },
                    /*{
                        label: "Eliminar",
                        icon: <DeleteIcon />,
                        action: handleAlertOpen,
                        showInMenu: true,
                    },*/
                ]}
                headerActions={[
                    {
                        label: "Crear Compañía",
                        icon: <AddBoxIcon />,
                        action: handleCreateCompany,
                    },
                ]}
            />

            {/* MODAL DE CREACIÓN / EDICIÓN DE COMPAÑÍA */}
            <DebFormModal
                maxWidth="sm"
                fullWidth={true}
                open={modalState}
                onClose={closeModal}
                onReject={closeModal}
                initialValues={modalInitialValues}
                onSubmit={handleSubmit}
                formikProps={{
                    enableReinitialize: true,
                    validationSchema: companyValidationSchema,
                }}
                headerText={
                    modalInitialValues?.id
                        ? "Editar Compañía"
                        : "Crear Compañía"
                }>
                <Stack spacing={1}>
                    <DebFormTextInput label={"Nombre"} name={"name"} />
                    <DebFormFilePicker label={"Seleccionar imagen de logo"} name={"logo"}/>
                    <DebFormTextInput label={"Dominio"} name={"dominio"} />
                    <DebFormTextInput label={"Extension"} name={"extension"} />
                    <DebFormTextInput
                        label={"URL de Conexión con debQ"}
                        name={"debqUrl"}
                    />
                    <DebFormTextInput
                        label={"Usuario de debQ"}
                        name={"debqUser"}
                    />
                    <DebFormPasswordInput
                        label={"Contraseña de debQ"}
                        name={"debqPassword"}
                    />
                    <DebFormTextInput
                        label={"Token de debQ"}
                        name={"debqToken"}
                    />
                </Stack>
            </DebFormModal>
            
            {/* ALERT DE ELIMINACIÓN */}
            <Dialog
                open={openAlert}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleAlertClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{m:"2rem 3rem 1rem 3rem", gap:"1rem", p:"0"}} >{"¿Esta seguro que desea eliminar?"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleAlertClose} variant="outlined" color="error">Cancelar</Button>
                <Button onClick={handleDelete} variant="contained" color="success">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default Companies;
